import { getAPIErrorMessage } from '../../utils/errormessages'
import { RESET, RESET_PASSWORD, RESET_PASSWORD_ERROR, RESET_PASSWORD_SUCCESS } from './forgotPasswordConstants'

const initialState = {
  error: '',
  resetSuccess: false,
  loading: false,
}
export default function forgotPasswordReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case RESET_PASSWORD:
      return {
        error: '',
        resetSuccess: false,
        loading: true,
      }
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetSuccess: true,
        loading: false,
      }
    case RESET_PASSWORD_ERROR: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: getAPIErrorMessage(action.payload.ErrorCode),
        loading: false,
      }
    }
    case RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
